export enum Triggers {
  VISITORS = 'visitors_page',
  PROFILE = 'profile',
  FAVORITES = 'favorites_page'
}
